import { render, staticRenderFns } from "./CollegeEmployer.vue?vue&type=template&id=0a2f9a47"
import script from "./CollegeEmployer.vue?vue&type=script&lang=js"
export * from "./CollegeEmployer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports